import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { OfferRoutingModule } from './offer-routing.module';
import {OfferComponent} from '../../app/layout/pages/offer/offer.component';
import {GeneralModule} from '../general/general.module';
import {NgbModule} from '@ng-bootstrap/ng-bootstrap';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {MatAutocompleteModule} from '@angular/material';
import {NgxPhoneSelectModule} from '../ngx-phone-select/ngx-phone-select.module';
import {TextMaskModule} from 'angular2-text-mask';
import {LazyLoadImageModule} from 'ng-lazyload-image';
import {OfferService} from '../../app/layout/pages/offer/offer.service';


@NgModule({
  declarations: [OfferComponent],
  imports: [
    CommonModule,
    OfferRoutingModule,
    GeneralModule,
    NgbModule,
    FormsModule,
    ReactiveFormsModule,
    MatAutocompleteModule,
    NgxPhoneSelectModule,
    TextMaskModule,
      LazyLoadImageModule
  ],
  providers: [OfferService]
})
export class OfferModule { }
